import { useEffect } from "react";
import routes from "./routes.json";

// Looks up the title/description for a route. The same data drives
// scripts/prerender-routes.js, so the pre-built HTML and the live page agree.
export function getPageMeta(path) {
  const page = routes.pages.find((p) => p.path === path);
  if (page) return page;

  const match = path.match(/^\/projects\/([^/]+)$/);
  const project = match && routes.projects.find((p) => p.id === match[1]);
  if (project) {
    return {
      path,
      title: `${project.name} | Mohamed Oulal`,
      description: `${project.name}: a ${project.type} built by Mohamed Oulal with ${project.technology}.`,
      image: project.image,
      imageAlt: project.imageAlt,
    };
  }
  return routes.pages[0];
}

function setMeta(selector, attr, value) {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

// Keeps the tab title, description, canonical URL and share tags in sync
// with the current page as visitors navigate around the site.
export default function usePageMeta(path) {
  useEffect(() => {
    const { title, description, image, imageAlt } = getPageMeta(path);
    const url = routes.siteUrl + (path === "/" ? "/" : path);

    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    // Project pages share their app icon; every other page shares the site-wide card.
    const imageUrl = routes.siteUrl + (image || routes.image);
    setMeta('meta[property="og:image"]', "content", imageUrl);
    setMeta('meta[name="twitter:image"]', "content", imageUrl);
    setMeta('meta[property="og:image:alt"]', "content", image ? imageAlt : "Mohamed Oulal, Senior Software Engineer");
  }, [path]);
}
